import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  padding: 32px 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 40px 32px;
    gap: 28px;
  }

  @media (min-width: 1200px) {
    padding: 48px 40px;
    gap: 32px;
  }
`;

export default Container;
